(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4120],{

/***/ 12117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_matcha_components_Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4203);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);




var TemplateImage = function TemplateImage(_ref) {
  var src = _ref.src,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
      type: "image/webp",
      src: "".concat(src)
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_segment_matcha_components_Image__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      src: src,
      alt: title,
      width: width,
      height: height,
      loading: "lazy"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TemplateImage);

/***/ }),

/***/ 64896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i3": function() { return /* reexport */ createSingleAbmIndustryPageQuery; },
  "Dh": function() { return /* reexport */ createSingleAbmPersonalPageQuery; },
  "v4": function() { return /* reexport */ createSingleContentDownloadConfirmationPageQuery; },
  "GR": function() { return /* reexport */ createSingleContentDownloadPageQuery; },
  "Gl": function() { return /* reexport */ createSingleDemoRequestPageQuery; },
  "qU": function() { return /* reexport */ createSinglePmmPageQuery; },
  "Kw": function() { return /* reexport */ createSingleVocVideoFeaturePageQuery; },
  "m9": function() { return /* reexport */ useSingleAbmIndustryPageQuery; },
  "x7": function() { return /* reexport */ useSingleAbmPersonalPageQuery; },
  "VB": function() { return /* reexport */ useSingleContentDownloadConfirmationPageQuery; },
  "c4": function() { return /* reexport */ useSingleContentDownloadPageQuery; },
  "uI": function() { return /* reexport */ useSingleDemoRequestPageQuery; },
  "y$": function() { return /* reexport */ useSinglePmmPageQuery; },
  "pF": function() { return /* reexport */ useSingleVocVideoFeaturePageQuery; }
});

// UNUSED EXPORTS: createAllAbmIndustryPagesQuery, createAllAbmPersonalPagesQuery, createAllContentDownloadConfirmationPagesQuery, createAllContentDownloadPagesQuery, createAllDemoRequestPagesQuery, createAllPmmPagesQuery, createAllVocVideoFeaturePagesQuery, useAllAbmIndustryPagesQuery, useAllAbmPersonalPagesQuery, useAllContentDownloadConfirmationPagesQuery, useAllContentDownloadPagesQuery, useAllDemoRequestPagesQuery, useAllPmmPagesQuery, useAllVocVideoFeaturePagesQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/templates/util.ts
var util = __webpack_require__(23683);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/abmIndustryPages.ts






function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var URL_PATH = "/content/entries/landingPageAbmIndustry";

var getTestimonials = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client) {
    var testimonials,
        testimonialsWithLogos,
        _args2 = arguments;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            testimonials = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : [];
            _context2.next = 3;
            return Promise.all(testimonials.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(testimonial) {
                var logo;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0,util/* retrieveMonoLogos */.NH)(client, [get_default()(testimonial, "fields.logo")]);

                      case 2:
                        logo = _context.sent;
                        return _context.abrupt("return", _objectSpread(_objectSpread({}, testimonial.fields), {}, {
                          logo: logo[0]
                        }));

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 3:
            testimonialsWithLogos = _context2.sent;
            return _context2.abrupt("return", sortBy_default()(testimonialsWithLogos, ["order"]));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getTestimonials(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAllAbmIndustryPages = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(client, options) {
    var url, response, transformedResponse;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url =  false ? 0 : URL_PATH;
            _context4.next = 3;
            return client.get(url, options);

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(templatePage) {
                var testimonials, relatedContent, resources, accordionsSection, accordions;
                return regenerator_default().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return getTestimonials(client, templatePage.testimonials);

                      case 2:
                        testimonials = _context3.sent;
                        _context3.next = 5;
                        return (0,util/* retrieveCards */.pj)(client, templatePage.relatedContent);

                      case 5:
                        relatedContent = _context3.sent;
                        _context3.next = 8;
                        return (0,util/* retrieveCards */.pj)(client, templatePage.resources);

                      case 8:
                        resources = _context3.sent;
                        accordionsSection = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.accordionsSection) || [];
                        accordions = accordionsSection.map(function (accordion) {
                          return get_default()(accordion, "fields", {});
                        });
                        return _context3.abrupt("return", _objectSpread(_objectSpread({}, templatePage), {}, {
                          hero: {
                            overline: get_default()(templatePage, "heroOverline", ""),
                            heading: get_default()(templatePage, "heroHeading", ""),
                            description: get_default()(templatePage, "heroDescription", ""),
                            image: (0,util/* convertAssetToMedia */.w4)(templatePage.heroImage)
                          },
                          testimonialSection: {
                            contentCard: {
                              heading: get_default()(templatePage, "headingContentCard", ""),
                              description: get_default()(templatePage, "descriptionContentCard", ""),
                              buttonText: get_default()(templatePage, "buttonTextContentCard", ""),
                              buttonLink: get_default()(templatePage, "buttonLinkContentCard", ""),
                              image: (0,util/* convertAssetToMedia */.w4)(templatePage.imageContentCard)
                            },
                            testimonials: testimonials
                          },
                          relatedContentSection: {
                            heading: get_default()(templatePage, "headingRelatedContent", ""),
                            description: get_default()(templatePage, "descriptionRelatedContent", ""),
                            relatedContent: relatedContent
                          },
                          accordionSection: {
                            securityCompliance: {
                              heading: get_default()(templatePage, "headingSecurityCompliance", ""),
                              description: get_default()(templatePage, "descriptionSecurityCompliance", ""),
                              linkText: get_default()(templatePage, "linkTextSecurityCompliance", ""),
                              linkUrl: get_default()(templatePage, "linkUrlSecurityCompliance", "")
                            },
                            heading: get_default()(templatePage, "headingSection", ""),
                            description: get_default()(templatePage, "descriptionSection", ""),
                            accordions: accordions,
                            image: (0,util/* convertAssetToMedia */.w4)(templatePage.imageSection),
                            downloadContent: {
                              link: get_default()(templatePage, "linkDownloadContent", ""),
                              buttonText: get_default()(templatePage, "buttonTextDownloadContent", "")
                            }
                          },
                          resourcesSection: {
                            heading: get_default()(templatePage, "headingResources", ""),
                            description: get_default()(templatePage, "descriptionResources", ""),
                            resources: resources
                          },
                          getADemoUtm: get_default()(templatePage, "getADemoUtm", ""),
                          seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {}))
                        }));

                      case 12:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x5) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context4.sent;
            return _context4.abrupt("return", sortBy_default()(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchAllAbmIndustryPages(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
var fetchAbmIndustryPage = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref5) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = _ref5.client, options = _ref5.options, slug = _ref5.slug;
            _context5.next = 3;
            return fetchAllAbmIndustryPages(client, options);

          case 3:
            templatePages = _context5.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context5.abrupt("return", data);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchAbmIndustryPage(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allAbmIndustryPagesQuery.ts



var createAllAbmIndustryPagesQuery = function createAllAbmIndustryPagesQuery(client) {
  return [["page", "allAbmIndustryPagesQuery"], function () {
    return fetchAllAbmIndustryPages(client);
  }];
};
var useAllAbmIndustryPagesQuery = (0,createQueryHook/* default */.Z)(createAllAbmIndustryPagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/abmPersonalPages.ts





function abmPersonalPages_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function abmPersonalPages_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? abmPersonalPages_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : abmPersonalPages_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var abmPersonalPages_URL_PATH = "/content/entries/landingPageAbmPersonal";
var fetchAllAbmPersonalPages = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(client, options) {
    var url, response, transformedResponse;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url =  false ? 0 : abmPersonalPages_URL_PATH;
            _context4.next = 3;
            return client.get(url, options);

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(templatePage) {
                var resources, featureBoxSectionBoxes, featureBoxes, profileCardsResponseArray, profileCards, accordionsSection, accordions, logoCarousel;
                return regenerator_default().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return (0,util/* retrieveCards */.pj)(client, templatePage.resources);

                      case 2:
                        resources = _context3.sent;
                        featureBoxSectionBoxes = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.featureBoxesFeatureBoxSection) || [];
                        _context3.next = 6;
                        return Promise.all(featureBoxSectionBoxes.map( /*#__PURE__*/function () {
                          var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(featureBox) {
                            var isVideo, featured, resp;
                            return regenerator_default().wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    isVideo = get_default()(featureBox, "fields.featured.sys.type") === "ResourceLink";

                                    if (!isVideo) {
                                      _context.next = 8;
                                      break;
                                    }

                                    _context.next = 4;
                                    return (0,util/* retrieveEmbeddedVideos */.ag)(client, [featureBox.fields.featured]);

                                  case 4:
                                    resp = _context.sent;
                                    featured = (0,util/* convertEmbedVideoToMedia */.xb)(resp[0]);
                                    _context.next = 9;
                                    break;

                                  case 8:
                                    featured = (0,util/* convertAssetToMedia */.w4)(featureBox.fields.featured);

                                  case 9:
                                    return _context.abrupt("return", {
                                      heading: get_default()(featureBox, "fields.heading", ""),
                                      body: get_default()(featureBox, "fields.body", ""),
                                      featured: featured
                                    });

                                  case 10:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));

                          return function (_x4) {
                            return _ref3.apply(this, arguments);
                          };
                        }()));

                      case 6:
                        featureBoxes = _context3.sent;
                        profileCardsResponseArray = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.profileCards) || [];
                        _context3.next = 10;
                        return Promise.all(profileCardsResponseArray.map( /*#__PURE__*/function () {
                          var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(profileCard) {
                            var isVideo, featured, resp;
                            return regenerator_default().wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    isVideo = get_default()(profileCard, "fields.featured.sys.type") === "ResourceLink";

                                    if (!isVideo) {
                                      _context2.next = 8;
                                      break;
                                    }

                                    _context2.next = 4;
                                    return (0,util/* retrieveEmbeddedVideos */.ag)(client, [profileCard.fields.featured]);

                                  case 4:
                                    resp = _context2.sent;
                                    featured = (0,util/* convertEmbedVideoToMedia */.xb)(resp[0]);
                                    _context2.next = 9;
                                    break;

                                  case 8:
                                    featured = (0,util/* convertAssetToMedia */.w4)(profileCard.fields.featured);

                                  case 9:
                                    return _context2.abrupt("return", {
                                      name: get_default()(profileCard, "fields.name", ""),
                                      title: get_default()(profileCard, "fields.title", ""),
                                      bio: get_default()(profileCard, "fields.bio", ""),
                                      featured: featured
                                    });

                                  case 10:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));

                          return function (_x5) {
                            return _ref4.apply(this, arguments);
                          };
                        }()));

                      case 10:
                        profileCards = _context3.sent;
                        accordionsSection = (templatePage === null || templatePage === void 0 ? void 0 : templatePage.accordionsSection) || [];
                        accordions = accordionsSection.map(function (accordion) {
                          return get_default()(accordion, "fields", {});
                        });

                        if (!templatePage.logoCarousel) {
                          _context3.next = 19;
                          break;
                        }

                        _context3.next = 16;
                        return (0,util/* retrieveColorLogos */.P4)(client, templatePage.logoCarousel);

                      case 16:
                        _context3.t0 = _context3.sent;
                        _context3.next = 20;
                        break;

                      case 19:
                        _context3.t0 = undefined;

                      case 20:
                        logoCarousel = _context3.t0;
                        return _context3.abrupt("return", abmPersonalPages_objectSpread(abmPersonalPages_objectSpread({}, templatePage), {}, {
                          companyName: get_default()(templatePage, "companyName", ""),
                          hero: {
                            image: (0,util/* convertAssetToMedia */.w4)(templatePage.heroImage),
                            heading: get_default()(templatePage, "heroHeading", ""),
                            description: get_default()(templatePage, "heroDescription", ""),
                            companyLogo: (0,util/* convertAssetToMedia */.w4)(templatePage.heroCompanyLogo),
                            logoCarousel: logoCarousel
                          },
                          section1: {
                            heading: get_default()(templatePage, "headingSection", ""),
                            description: get_default()(templatePage, "descriptionSection", ""),
                            image: (0,util/* convertAssetToMedia */.w4)(templatePage.imageSection),
                            accordions: accordions,
                            featureBoxSection: {
                              featureBox1: featureBoxes[0],
                              featureBox2: featureBoxes[1]
                            },
                            profileCardSection: {
                              profileCard1: profileCards[0],
                              profileCard2: profileCards[1]
                            }
                          },
                          section2: {
                            callToActionHeading: get_default()(templatePage, "callToActionHeadingResourcesSection", ""),
                            resources: resources
                          },
                          seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {})),
                          demoUtms: get_default()(templatePage, "demoUtms", "")
                        }));

                      case 22:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context4.sent;
            return _context4.abrupt("return", sortBy_default()(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchAllAbmPersonalPages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchAbmPersonalPage = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref5) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = _ref5.client, options = _ref5.options, slug = _ref5.slug;
            _context5.next = 3;
            return fetchAllAbmPersonalPages(client, options);

          case 3:
            templatePages = _context5.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context5.abrupt("return", data);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchAbmPersonalPage(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allAbmPersonalPagesQuery.ts



var createAllAbmPersonalPagesQuery = function createAllAbmPersonalPagesQuery(client) {
  return [["page", "allAbmPersonalPagesQuery"], function () {
    return fetchAllAbmPersonalPages(client);
  }];
};
var useAllAbmPersonalPagesQuery = (0,createQueryHook/* default */.Z)(createAllAbmPersonalPagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/contentDownloadConfirmationPages.ts






function contentDownloadConfirmationPages_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function contentDownloadConfirmationPages_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? contentDownloadConfirmationPages_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : contentDownloadConfirmationPages_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var contentDownloadConfirmationPages_URL_PATH = "/content/entries/landingPageContentDownloadConfirmation";
var fetchAllContentDownloadConfirmationPages = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client, options) {
    var url, response, transformedResponse;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url =  false ? 0 : contentDownloadConfirmationPages_URL_PATH;
            _context2.next = 3;
            return client.get(url, options);

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(templatePage) {
                var logoCarousel;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!templatePage.logoCarousel) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 3;
                        return (0,util/* retrieveColorLogos */.P4)(client, templatePage.logoCarousel);

                      case 3:
                        _context.t0 = _context.sent;
                        _context.next = 7;
                        break;

                      case 6:
                        _context.t0 = undefined;

                      case 7:
                        logoCarousel = _context.t0;
                        return _context.abrupt("return", contentDownloadConfirmationPages_objectSpread(contentDownloadConfirmationPages_objectSpread({}, templatePage), {}, {
                          hero: {
                            heading: get_default()(templatePage, "heroHeading", ""),
                            description: get_default()(templatePage, "heroDescription", ""),
                            buttonText: get_default()(templatePage, "ctaButtonText", ""),
                            contentLink: get_default()(templatePage, "ctaLink", "")
                          },
                          section: {
                            heading: get_default()(templatePage, "headingSection", ""),
                            description: get_default()(templatePage, "descriptionSection", ""),
                            customFormId: get_default()(templatePage, "ctaCustomFormId", ""),
                            logoCarousel: logoCarousel,
                            displayProductTourOrDemoForm: get_default()(templatePage, "displayProductTourOrDemoForm", "")
                          },
                          seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {}))
                        }));

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context2.sent;
            return _context2.abrupt("return", sortBy_default()(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllContentDownloadConfirmationPages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchContentDownloadConfirmationPage = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context3.next = 3;
            return fetchAllContentDownloadConfirmationPages(client, options);

          case 3:
            templatePages = _context3.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchContentDownloadConfirmationPage(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allContentDownloadConfirmationPagesQuery.ts



var createAllContentDownloadConfirmationPagesQuery = function createAllContentDownloadConfirmationPagesQuery(client) {
  return [["page", "allContentDownloadConfirmationPagesQuery"], function () {
    return fetchAllContentDownloadConfirmationPages(client);
  }];
};
var useAllContentDownloadConfirmationPagesQuery = (0,createQueryHook/* default */.Z)(createAllContentDownloadConfirmationPagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/contentDownloadPages.ts






function contentDownloadPages_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function contentDownloadPages_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? contentDownloadPages_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : contentDownloadPages_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var contentDownloadPages_URL_PATH = "/content/entries/landingPageContentDownload";
var fetchAllContentDownloadPages = function fetchAllContentDownloadPages(client, options) {
  var url =  false ? 0 : contentDownloadPages_URL_PATH;
  return client.get(url, options).then(function (res) {
    var transformedResponse = res.map(function (templatePage) {
      return contentDownloadPages_objectSpread(contentDownloadPages_objectSpread({}, templatePage), {}, {
        hero: {
          overline: get_default()(templatePage, "heroOverline", ""),
          heading: get_default()(templatePage, "heroHeading", ""),
          underImageText: get_default()(templatePage, "underImageText", ""),
          image: (0,util/* convertAssetToMedia */.w4)(templatePage.heroImage)
        },
        cta: {
          buttonText: get_default()(templatePage, "ctaButtonText", ""),
          customFormId: get_default()(templatePage, "ctaCustomFormId", ""),
          confirmationPagePath: get_default()(templatePage, "confirmationPage.fields.slug", "")
        },
        section: {
          heading: get_default()(templatePage, "headingSection", ""),
          description: get_default()(templatePage, "descriptionSection", "")
        },
        seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {}))
      });
    });
    return sortBy_default()(transformedResponse, function (item) {
      return item.title;
    });
  });
};
var fetchContentDownloadPage = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, options = _ref.options, slug = _ref.slug;
            _context.next = 3;
            return fetchAllContentDownloadPages(client, options);

          case 3:
            templatePages = _context.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchContentDownloadPage(_x) {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allContentDownloadPagesQuery.ts



var createAllContentDownloadPagesQuery = function createAllContentDownloadPagesQuery(client) {
  return [["page", "allContentDownloadPagesQuery"], function () {
    return fetchAllContentDownloadPages(client);
  }];
};
var useAllContentDownloadPagesQuery = (0,createQueryHook/* default */.Z)(createAllContentDownloadPagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/demoRequestPages.ts






function demoRequestPages_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function demoRequestPages_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? demoRequestPages_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : demoRequestPages_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var demoRequestPages_URL_PATH = "/content/entries/landingPageDemoRequest";
var fetchAllDemoRequestPages = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client, options) {
    var url, response, transformedResponse;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url =  false ? 0 : demoRequestPages_URL_PATH;
            _context2.next = 3;
            return client.get(url, options);

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(templatePage) {
                var logos;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0,util/* retrieveColorLogos */.P4)(client, templatePage.logoGrid);

                      case 2:
                        logos = _context.sent;
                        return _context.abrupt("return", demoRequestPages_objectSpread(demoRequestPages_objectSpread({}, templatePage), {}, {
                          form: {
                            overline: get_default()(templatePage, "formOverline", ""),
                            heading: get_default()(templatePage, "formHeading", ""),
                            description: get_default()(templatePage, "formDescription", ""),
                            formId: get_default()(templatePage, "demoFormId", "")
                          },
                          logoGrid: {
                            heading: get_default()(templatePage, "logoGridHeading", ""),
                            description: get_default()(templatePage, "logoGridDescription", ""),
                            logos: logos
                          },
                          seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {}))
                        }));

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context2.sent;
            return _context2.abrupt("return", sortBy_default()(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllDemoRequestPages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchDemoRequestPage = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context3.next = 3;
            return fetchAllDemoRequestPages(client, options);

          case 3:
            templatePages = _context3.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchDemoRequestPage(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allDemoRequestPagesQuery.ts



var createAllDemoRequestPagesQuery = function createAllDemoRequestPagesQuery(client) {
  return [["page", "allDemoRequestPagesQuery"], function () {
    return fetchAllDemoRequestPages(client);
  }];
};
var useAllDemoRequestPagesQuery = (0,createQueryHook/* default */.Z)(createAllDemoRequestPagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/pmmPages.ts






function pmmPages_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function pmmPages_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? pmmPages_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pmmPages_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var pmmPages_URL_PATH = "/content/entries/landingPagePmm";
var fetchAllPmmPages = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client, options) {
    var url, response, transformedResponse;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url =  false ? 0 : pmmPages_URL_PATH;
            _context2.next = 3;
            return client.get(url, options);

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(templatePage) {
                var logos;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!templatePage.logoCarousel) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 3;
                        return (0,util/* retrieveColorLogos */.P4)(client, templatePage.logoCarousel);

                      case 3:
                        _context.t0 = _context.sent;
                        _context.next = 7;
                        break;

                      case 6:
                        _context.t0 = undefined;

                      case 7:
                        logos = _context.t0;
                        return _context.abrupt("return", pmmPages_objectSpread(pmmPages_objectSpread({}, templatePage), {}, {
                          hero: {
                            overline: get_default()(templatePage, "heroOverline", ""),
                            heading: get_default()(templatePage, "heroHeading", ""),
                            description: get_default()(templatePage, "heroDescription", ""),
                            image: (0,util/* convertAssetToMedia */.w4)(templatePage.heroImage),
                            ctaText: get_default()(templatePage, "heroCtaText", ""),
                            formId: get_default()(templatePage, "ctaCustomFormId", "")
                          },
                          logoCarousel: {
                            heading: get_default()(templatePage, "labelTextLogoCarousel", ""),
                            logos: logos
                          },
                          section: {
                            heading: get_default()(templatePage, "headingSection", ""),
                            description: get_default()(templatePage, "descriptionSection", ""),
                            valueProps: get_default()(templatePage, "valuePropsSection", []).map(function (valueProp) {
                              return {
                                heading: get_default()(valueProp, "fields.heading", ""),
                                description: get_default()(valueProp, "fields.description", ""),
                                featuredContent: get_default()(valueProp, "fields.featuredContent", []).map(function (featuredContentItem) {
                                  return {
                                    heading: get_default()(featuredContentItem, "fields.heading", ""),
                                    body: get_default()(featuredContentItem, "fields.body", "")
                                  };
                                }),
                                badge1: get_default()(valueProp, "fields.badges.fields.badge1", ""),
                                badge2: get_default()(valueProp, "fields.badges.fields.badge2", ""),
                                image: (0,util/* convertAssetToMedia */.w4)(get_default()(valueProp, "fields.image", undefined)),
                                callToAction: {
                                  text: get_default()(valueProp, "fields.callToAction.fields.text", ""),
                                  url: get_default()(valueProp, "fields.callToAction.fields.url", "")
                                }
                              };
                            })
                          },
                          featureBoxSection: {
                            heading: get_default()(templatePage, "headingFeatureBoxSection", ""),
                            description: get_default()(templatePage, "descriptionFeatureBoxSection", ""),
                            featureBoxes: get_default()(templatePage, "featureBoxesFeatureBoxSection", []).map(function (featureBox) {
                              return {
                                heading: get_default()(featureBox, "fields.heading", ""),
                                body: get_default()(featureBox, "fields.body", "")
                              };
                            })
                          },
                          seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {}))
                        }));

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context2.sent;
            return _context2.abrupt("return", sortBy_default()(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllPmmPages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchPmmPage = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context3.next = 3;
            return fetchAllPmmPages(client, options);

          case 3:
            templatePages = _context3.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchPmmPage(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allPmmPagesQuery.ts



var createAllPmmPagesQuery = function createAllPmmPagesQuery(client) {
  return [["page", "allPmmPagesQuery"], function () {
    return fetchAllPmmPages(client);
  }];
};
var useAllPmmPagesQuery = (0,createQueryHook/* default */.Z)(createAllPmmPagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/templates/vocVideoFeaturePages.ts






function vocVideoFeaturePages_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function vocVideoFeaturePages_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? vocVideoFeaturePages_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : vocVideoFeaturePages_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var vocVideoFeaturePages_URL_PATH = "/content/entries/landingPageVocVideoFeature";
var fetchAllVocVideoFeaturePages = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client, options) {
    var url, response, transformedResponse;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url =  false ? 0 : vocVideoFeaturePages_URL_PATH;
            _context2.next = 3;
            return client.get(url, options);

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return Promise.all(response.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(templatePage) {
                var relatedContentCards, logoCarousel;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!templatePage.relatedContent) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 3;
                        return (0,util/* retrieveCards */.pj)(client, templatePage.relatedContent);

                      case 3:
                        _context.t0 = _context.sent;
                        _context.next = 7;
                        break;

                      case 6:
                        _context.t0 = [];

                      case 7:
                        relatedContentCards = _context.t0;

                        if (!templatePage.logoCarousel) {
                          _context.next = 14;
                          break;
                        }

                        _context.next = 11;
                        return (0,util/* retrieveColorLogos */.P4)(client, templatePage.logoCarousel);

                      case 11:
                        _context.t1 = _context.sent;
                        _context.next = 15;
                        break;

                      case 14:
                        _context.t1 = undefined;

                      case 15:
                        logoCarousel = _context.t1;
                        return _context.abrupt("return", vocVideoFeaturePages_objectSpread(vocVideoFeaturePages_objectSpread({}, templatePage), {}, {
                          hero: {
                            overline: get_default()(templatePage, "heroOverline", ""),
                            heading: get_default()(templatePage, "heroHeading", ""),
                            formId: get_default()(templatePage, "ctaCustomFormId", ""),
                            videoLink: get_default()(templatePage, "heroVideoLink", ""),
                            videoDescription: get_default()(templatePage, "heroVideoDescription", ""),
                            videoCoverImage: (0,util/* convertAssetToMedia */.w4)(templatePage.heroVideoCoverImage),
                            logoCarousel: logoCarousel
                          },
                          relatedContent: {
                            cards: relatedContentCards
                          },
                          seo: (0,util/* convertSeoMetaResponseToSeoMeta */.k_)(get_default()(templatePage, "seo.fields", {}))
                        }));

                      case 17:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            transformedResponse = _context2.sent;
            return _context2.abrupt("return", sortBy_default()(transformedResponse, function (item) {
              return item.title;
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllVocVideoFeaturePages(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchVocVideoFeaturePage = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref3) {
    var client, options, slug, templatePages, data;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context3.next = 3;
            return fetchAllVocVideoFeaturePages(client, options);

          case 3:
            templatePages = _context3.sent;
            data = templatePages.find(function (item) {
              return item.slug === slug;
            });
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchVocVideoFeaturePage(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/allVocVideoFeaturePagesQuery.ts



var createAllVocVideoFeaturePagesQuery = function createAllVocVideoFeaturePagesQuery(client) {
  return [["page", "allVocVideoFeaturePagesQuery"], function () {
    return fetchAllVocVideoFeaturePages(client);
  }];
};
var useAllVocVideoFeaturePagesQuery = (0,createQueryHook/* default */.Z)(createAllVocVideoFeaturePagesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singleAbmIndustryPageQuery.ts



var createSingleAbmIndustryPageQuery = function createSingleAbmIndustryPageQuery(client, slug) {
  return [["templatePages/singleAbmIndustryPageQuery", slug], function () {
    return fetchAbmIndustryPage({
      client: client,
      slug: slug
    });
  }];
};
var useSingleAbmIndustryPageQuery = (0,createQueryHook/* default */.Z)(createSingleAbmIndustryPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singleAbmPersonalPageQuery.ts



var createSingleAbmPersonalPageQuery = function createSingleAbmPersonalPageQuery(client, slug) {
  return [["templatePages/singleAbmPersonalPageQuery", slug], function () {
    return fetchAbmPersonalPage({
      client: client,
      slug: slug
    });
  }];
};
var useSingleAbmPersonalPageQuery = (0,createQueryHook/* default */.Z)(createSingleAbmPersonalPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singleContentDownloadConfirmationPageQuery.ts



var createSingleContentDownloadConfirmationPageQuery = function createSingleContentDownloadConfirmationPageQuery(client, slug) {
  return [["templatePages/singleContentDownloadConfirmationPageQuery", slug], function () {
    return fetchContentDownloadConfirmationPage({
      client: client,
      slug: slug
    });
  }];
};
var useSingleContentDownloadConfirmationPageQuery = (0,createQueryHook/* default */.Z)(createSingleContentDownloadConfirmationPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singleContentDownloadPageQuery.ts



var createSingleContentDownloadPageQuery = function createSingleContentDownloadPageQuery(client, slug) {
  return [["templatePages/singleContentDownloadPageQuery", slug], function () {
    return fetchContentDownloadPage({
      client: client,
      slug: slug
    });
  }];
};
var useSingleContentDownloadPageQuery = (0,createQueryHook/* default */.Z)(createSingleContentDownloadPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singleDemoRequestPageQuery.ts



var createSingleDemoRequestPageQuery = function createSingleDemoRequestPageQuery(client, slug) {
  return [["templatePages/singleDemoRequestPageQuery", slug], function () {
    return fetchDemoRequestPage({
      client: client,
      slug: slug
    });
  }];
};
var useSingleDemoRequestPageQuery = (0,createQueryHook/* default */.Z)(createSingleDemoRequestPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singlePmmPageQuery.ts



var createSinglePmmPageQuery = function createSinglePmmPageQuery(client, slug) {
  return [["templatePages/singlePmmPageQuery", slug], function () {
    return fetchPmmPage({
      client: client,
      slug: slug
    });
  }];
};
var useSinglePmmPageQuery = (0,createQueryHook/* default */.Z)(createSinglePmmPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/singleVocVideoFeaturePageQuery.ts



var createSingleVocVideoFeaturePageQuery = function createSingleVocVideoFeaturePageQuery(client, slug) {
  return [["templatePages/singleVocVideoFeaturePageQuery", slug], function () {
    return fetchVocVideoFeaturePage({
      client: client,
      slug: slug
    });
  }];
};
var useSingleVocVideoFeaturePageQuery = (0,createQueryHook/* default */.Z)(createSingleVocVideoFeaturePageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/template/queries/index.ts















/***/ }),

/***/ 23683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ getBaseMediaType; },
/* harmony export */   "NH": function() { return /* binding */ retrieveMonoLogos; },
/* harmony export */   "P4": function() { return /* binding */ retrieveColorLogos; },
/* harmony export */   "ag": function() { return /* binding */ retrieveEmbeddedVideos; },
/* harmony export */   "k_": function() { return /* binding */ convertSeoMetaResponseToSeoMeta; },
/* harmony export */   "pj": function() { return /* binding */ retrieveCards; },
/* harmony export */   "w4": function() { return /* binding */ convertAssetToMedia; },
/* harmony export */   "xb": function() { return /* binding */ convertEmbedVideoToMedia; }
/* harmony export */ });
/* unused harmony exports CONTENT_PREVIEW_PARAMETER, retrieveDownloadOnSubmitForms */
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20406);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72579);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2__);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var CONTENT_PREVIEW_PARAMETER = "contentPreview";
var COMPANY_COMPANY_LOGO_URL_PATH = "/content/entries/companyLogo";
var INTEGRATION_COMPANY_LOGO_URL_PATH = "/content/entries/integrationLogoGlobal";
var CARD_URL_PATH = "/content/entries/card";
var EMBED_VIDEO_URL_PATH = "/content/entries/embeddedVideo";
var DOWNLOAD_ON_SUBMIT_FORM_URL_PATH = "/content/entries/downloadOnSubmitForm";
var BLANK_MEDIA = {
  title: "",
  src: "",
  contentType: "",
  width: 0,
  height: 0
};
var getBaseMediaType = function getBaseMediaType(contentType) {
  return contentType ? contentType.split("/")[0] : "unknown";
};
var convertAssetToMedia = function convertAssetToMedia(asset) {
  return asset ? {
    title: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(asset, "fields.title", ""),
    src: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(asset, "fields.file.url", ""),
    contentType: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(asset, "fields.file.contentType", ""),
    width: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(asset, "fields.file.details.image.width", ""),
    height: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(asset, "fields.file.details.image.height", "")
  } : BLANK_MEDIA;
};
var convertEmbedVideoToMedia = function convertEmbedVideoToMedia(embedVideo) {
  return embedVideo ? {
    title: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(embedVideo, "name", ""),
    src: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(embedVideo, "embedUrl", ""),
    contentType: "Embed Video",
    width: 0,
    height: 0,
    structuredData: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(embedVideo, "structuredData", {})
  } : BLANK_MEDIA;
};

var deriveIdFromUrn = function deriveIdFromUrn(urn) {
  var urnParts = urn.split("/");
  return urnParts[urnParts.length - 1];
};

var retrieveColorLogos = /*#__PURE__*/function () {
  var _ref = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee(client, logos) {
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", retrieveLogos(client, logos));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function retrieveColorLogos(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var retrieveMonoLogos = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee2(client, logos) {
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", retrieveLogos(client, logos, "logoMono"));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function retrieveMonoLogos(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var retrieveLogos = /*#__PURE__*/function () {
  var _ref3 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee3(client) {
    var logos,
        logoField,
        logoIds,
        companyLogoResponse,
        integrationLogoResponse,
        _args3 = arguments;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            logos = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
            logoField = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "logoColor";
            logoIds = logos.map(function (logo) {
              return deriveIdFromUrn(logo.sys.urn);
            });
            _context3.next = 5;
            return client.get("".concat(COMPANY_COMPANY_LOGO_URL_PATH, "?select=sys.id,fields.").concat(logoField, "&sys.id[in]=").concat(logoIds.join(","), "&order=sys.id"));

          case 5:
            companyLogoResponse = _context3.sent;
            _context3.next = 8;
            return client.get("".concat(INTEGRATION_COMPANY_LOGO_URL_PATH, "?select=sys.id,fields.").concat(logoField, "&sys.id[in]=").concat(logoIds.join(","), "&order=sys.id"));

          case 8:
            integrationLogoResponse = _context3.sent;
            return _context3.abrupt("return", companyLogoResponse.concat(integrationLogoResponse).map(function (logo) {
              return convertAssetToMedia(logo[logoField]);
            }));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function retrieveLogos(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

var retrieveCards = /*#__PURE__*/function () {
  var _ref4 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee4(client) {
    var cardResources,
        cardResrourceIds,
        cardResponse,
        _args4 = arguments;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            cardResources = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : [];
            cardResrourceIds = cardResources.map(function (cardResource) {
              return deriveIdFromUrn(cardResource.sys.urn);
            });
            _context4.next = 4;
            return client.get("".concat(CARD_URL_PATH, "?sys.id[in]=").concat(cardResrourceIds.join(","), "&order=sys.id"));

          case 4:
            cardResponse = _context4.sent;
            return _context4.abrupt("return", cardResponse.map(function (card) {
              return {
                heading: card.cardHeading,
                description: card.cardDescription,
                url: card.cardUrl,
                ctaLinkText: card.cardCtaText
              };
            }));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function retrieveCards(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
var retrieveEmbeddedVideos = /*#__PURE__*/function () {
  var _ref5 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee5(client) {
    var embeddedVideoResources,
        embeddedVideoResourceIds,
        embeddedVideoResponse,
        _args5 = arguments;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            embeddedVideoResources = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : [];
            embeddedVideoResourceIds = embeddedVideoResources.map(function (embeddedVideoResource) {
              return deriveIdFromUrn(embeddedVideoResource.sys.urn);
            });
            _context5.next = 4;
            return client.get("".concat(EMBED_VIDEO_URL_PATH, "?sys.id[in]=").concat(embeddedVideoResourceIds.join(","), "&order=sys.id"));

          case 4:
            embeddedVideoResponse = _context5.sent;
            return _context5.abrupt("return", embeddedVideoResponse);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function retrieveEmbeddedVideos(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
var retrieveDownloadOnSubmitForms = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(client) {
    var downloadOnSubmitResources,
        downloadOnSubmitResourceIds,
        downloadOnSubmitResponse,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            downloadOnSubmitResources = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : [];
            downloadOnSubmitResourceIds = downloadOnSubmitResources.map(function (downloadOnSubmitResource) {
              return deriveIdFromUrn(downloadOnSubmitResource.sys.urn);
            });
            _context6.next = 4;
            return client.get("".concat(DOWNLOAD_ON_SUBMIT_FORM_URL_PATH, "?sys.id[in]=").concat(downloadOnSubmitResourceIds.join(","), "&order=sys.id"));

          case 4:
            downloadOnSubmitResponse = _context6.sent;
            return _context6.abrupt("return", downloadOnSubmitResponse);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function retrieveDownloadOnSubmitForms(_x8) {
    return _ref6.apply(this, arguments);
  };
}()));

var convertRobotRestrictionsToDirective = function convertRobotRestrictionsToDirective(restrictions) {
  if (restrictions === "All robots restrictions") {
    return "noindex, nofollow, noarchive, nosnippet, noimageindex";
  }

  return "all";
};

var convertSeoMetaResponseToSeoMeta = function convertSeoMetaResponseToSeoMeta(seoMetaResponse) {
  if (!seoMetaResponse) {
    return {
      pageTitle: "",
      pageDescription: "",
      robotsDirective: "",
      ogImage: {
        title: "",
        src: ""
      }
    };
  }

  return _objectSpread(_objectSpread({}, seoMetaResponse), {}, {
    pageDescription: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(seoMetaResponse, "pageDescription", ""),
    pageTitle: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(seoMetaResponse, "pageTitle", ""),
    robotsDirective: convertRobotRestrictionsToDirective(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(seoMetaResponse, "robotsRestrictions", "")),
    ogImage: {
      title: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(seoMetaResponse, "ogImage.fields.title", ""),
      src: lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(seoMetaResponse, "ogImage.fields.file.url", "")
    }
  });
};

/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 96827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ _404; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
;// CONCATENATED MODULE: ../../libs/next-shared/404/data.json
var data_namespaceObject = JSON.parse('[{"text":"Segment Home","url":"https://segment.com/"},{"text":"Docs","url":"https://segment.com/docs/"},{"text":"Login","url":"https://segment.com/login/"},{"text":"Customer AI","url":"https://segment.com/solutions/ai/"},{"text":"HTTP API Source","url":"https://segment.com/docs/sources/server/http/"},{"text":"Get a Demo","url":"https://segment.com/demo/"},{"text":"Data Hub","url":"https://segment.com/data-hub/"},{"text":"Growth Center","url":"https://segment.com/growth-center/"},{"text":"Resources","url":"https://segment.com/resources/"},{"text":"Blog","url":"https://segment.com/blog/"}]');
// EXTERNAL MODULE: ../../libs/next-shared/404/assets/Error.webp
var Error = __webpack_require__(19282);
var Error_default = /*#__PURE__*/__webpack_require__.n(Error);
// EXTERNAL MODULE: ../../libs/next-shared/404/assets/Error@2x.webp
var Error_2x = __webpack_require__(55901);
var Error_2x_default = /*#__PURE__*/__webpack_require__.n(Error_2x);
// EXTERNAL MODULE: ../../libs/next-shared/404/assets/Error@2x.png
var assets_Error_2x = __webpack_require__(90490);
var assets_Error_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Error_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/next-shared/404/404.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}















var copy = {
  heading: "Whoops!",
  description: "Error code: 404. Unfortunately, the page you are looking for does not exist.",
  error: "Here are some helpful links instead:"
};

var ErrorView = function ErrorView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(layout/* default */.Z, {
      pageTitle: "404 | Twilio Segment",
      pageDescription: "",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
          variant: "2Col",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "h1",
                children: copy.heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pExtraLarge",
                children: copy.description
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
              variant: "pExtraLarge",
              children: copy.error
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
              columns: 1,
              overrides: {
                sm: 2
              },
              children: data_namespaceObject.map(function (el) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonTextWrapper, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                    tag: "a",
                    size: "medium",
                    href: el.url,
                    children: el.text
                  })
                }, el.text);
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
            alignSelf: "center",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                type: "image/webp",
                srcSet: "".concat((Error_default()), ", ").concat((Error_2x_default()), " 2x")
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                width: "641",
                height: "555",
                src: (assets_Error_2x_default()),
                alt: "Collect Data Details",
                loading: "lazy"
              })]
            })
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var _404 = (ErrorView);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fr5jqi3"
} : 0)("display:grid;flex-direction:column;align-items:center;min-height:100vh;grid-template-rows:max-content;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1fr5jqi2"
} : 0)("row-gap:0;margin-bottom:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var StyledButtonTextWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fr5jqi1"
} : 0)( true ? "" : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1fr5jqi0"
} : 0)( true ? {
  name: "1eclne9",
  styles: "max-width:360px"
} : 0);
;// CONCATENATED MODULE: ../../libs/next-shared/404/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(31576);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/index.ts + 30 modules
var Navigation2_MobileNavigation = __webpack_require__(46452);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90429);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx







var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation2_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(76647);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation2/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(97182);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx






var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58943);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useQuery
 */

var createQueryHook = function createQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery.apply */ .a.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createQueryHook);

/***/ }),

/***/ 31629:
/***/ (function(module) {

module.exports = "/_next/static/images/OgDefault-d7b3c7db5fe8313523e98ed96fa0d6d6.jpeg";

/***/ }),

/***/ 90490:
/***/ (function(module) {

module.exports = "/_next/static/images/Error@2x-fed5968fdecab1fac471000d1a501a5f.png";

/***/ }),

/***/ 19282:
/***/ (function(module) {

module.exports = "/_next/static/images/Error-1cf5b1c4a99d1faec03c30c5e9fd5e64.webp";

/***/ }),

/***/ 55901:
/***/ (function(module) {

module.exports = "/_next/static/images/Error@2x-4995b132adf9c49b6cfb16e99e6fc77f.webp";

/***/ })

}]);